import { defineComponent as _defineComponent } from 'vue'


  interface Props {
    title: string;
    active: boolean;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'GreenButton',
  props: {
    title: {},
    active: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})